<template>
  <b-container v-if="renderPage">
    <b-row class="mb-4  column-change">
      <b-col
        xl="8"
        lg="7"
        sm="12"
      >
        <info-card :data="res" />
        <progress-bar-transaction
          v-if="showProgressBar"
          :data="res"
        />
        <time-line-transaction
          v-if="!showProgressBar"
          :data="res"
        />
        <controllers-buttons
          v-if="res.link.status == 11 || res.link.status == 5 || res.link.status == 1"
          type="recurrence-link"
          :data="res"
        />
      </b-col>
      <b-col
        v-if="res.link.status !== 2 && res.link.status !== 5 && res.link.status !== 11 && res.link.status !== 12"
        md="12"
        class="mb-1"
        lg="5"
        xl="4"
      >
        <Receipt
          :receipt-data="res"
          type="recurrence"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BContainer,
  BRow,
  BCol,
} from 'bootstrap-vue'

import ControllersButtons from '@/layouts/components/DetailsTransaction/ControllersButtons.vue'
import InfoCard from '@/layouts/components/DetailsTransaction/InfoCard.vue'
import ProgressBarTransaction from '@/layouts/components/DetailsTransaction/ProgressBarTransaction.vue'
import Receipt from '@/layouts/components/Receipt.vue'
import TimeLineTransaction from '@/layouts/components/DetailsTransaction/TimeLineTransaction.vue'

import { getRecurrence } from '@/service/transaction/transaction'

import { callLoading } from '@/service/utilities/utilities'

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    ControllersButtons,
    Receipt,
    InfoCard,
    ProgressBarTransaction,
    TimeLineTransaction,
  },
  data() {
    return {
      renderPage: false,
      link: '',
      showProgressBar: true,
      res: {
        link: {},
        payment: {},
        product: {},
        customer: {},
        user: {},
      },
    }
  },

  beforeRouteLeave(to, from, next) {
    this.renderPage = false
    next()
  },

  async mounted() {
    callLoading(true)
    await this.handleGetData()
    this.handleCheckScreenSize()
    window.addEventListener('resize', this.handleCheckScreenSize)
    callLoading(false)
    this.renderPage = true
  },

  methods: {
    async handleGetData() {
      try {
        const hash = window.location.pathname.split('/')[4]
        const { data, status } = await getRecurrence(hash)

        this.link = `${process.env.VUE_APP_URL}link-recorrencia/1/${hash}`

        if (status !== 200) {
          this.$router.push('/error404')
          return
        }
        this.res = data
      } catch {
        this.$router.push('/error404')
      }
    },
    handleCheckScreenSize() {
      this.showProgressBar = window.innerWidth > 1200
    },
  },
}
</script>
